<template>
    <div class="site-footer ">

        <div class="row pad-in">
            <div class="col s3 m1 yo-align-center" v-on:click="nosoap">
                <img src="../assets/IFCC-white.png" style="padding-top:8px;" />
            </div>
            <div class="col s5m m1m yo-align-center" >
                <img src="../assets/EFLM-white.png" style="padding-top:22px;height:52px;" />
            </div>
            <div class="col s3m m1m yo-align-left" >
                <img src="../assets/SEQCML-white.png" style="padding-top:22px;height:50px;" />
            </div>

            <div class="col s12 yo-hidden yo-show-phone" style="height:12px;">&#160;</div>
            
            <div class="col s12 m6m" >
                <b>ORGANISING SECRETARIAT</b>
                <div class="row pad">
                    <div class="col s4 ms1m yo-align-left" >
                        <img src="../assets/MZ.png" style="height:52px;padding-top:4px;" />
                    </div>

                    <div class="col s8 m10">
                    <b>MZ Congressi s.r.l.</b>
                    <br>
                    Member of the MZ International Group
                    <br>
                    Individual Company subject to management and coordination by MZ International Group s.r.l.
                    </div>
                </div>

                <div class="row pad yo-text-s" style="border-top: 1px solid #ffffff;padding:8px 0;margin-top:20px;">
                    <div class="col s12 m6 yo-align-left">Via Carlo Farini 81 - 20159 Milano (Italy)</div>
                    <div class="col s12 m6 yo-align-right">info@euromedlab2019barcelona.org</div>
                    <div class="col s6 m6 yo-align-left">Phone: +39 02 66802323</div>
                    <div class="col s6 m6 yo-align-right">Fax: +39 02 6686699</div>
                </div>
                <div class="row pad yo-text-s" style="border-top: 1px solid #ffffff;padding-top:4px;">
                    <div class="col s12 yo-align-right"><a href="https://www.mzcongressi.com/documenti/privacy-en.pdf" target="_blank" style="color:#ffffff;">Privacy Policy</a></div>
                </div>
            </div>

            <div class="col s12 m1m yo-align-right" >
                <a href="http://www.seoul2020.org/2020"><img src="/2019/images/worldlab.png" style="padding-top:2px;height:130px;" /></a>
                <br /><br />
                <a href="https://www.facebook.com/EuromedlabBarcelona2019/"><img src="../assets/facebook.png" style="padding-top:2px;height:36px;" /></a>
            </div>

        </div>

        

<!--
        <div class="row container">
            <div class="col col-s6">
            FOOTER LEFT
            </div>

            <div class="col col-s6">
            FOOTER RIGHT
            </div>
        </div>
-->        
    </div>
</template>

<script>

export default {
  name: 'site-footer',
  components: {
  },
    methods: {

      nosoap(){
          this.$axios.credential = false
        var argo = {action: 'test', idEvento: 999}
        this.$axios.post('https://www.mzcongressi.com:8443/JemsService/JService',argo).then((response) => {
        //this.$axios.get('https://www.mzcongressi.com:8443/JemsService/JService?action=generaAttestatoPartecipazione&idIscrizione='+3443+'&isOspite=false&idEvento='+999).then((response) => {
          console.log(response)
          this.$alert('Complimenti, la riposta è:'+response.data, 'JAVA SERVERLET', {confirmButtonText: 'Chiudi' })
        }).catch((error) => {

            this.$alert('Errore, la riposta è:'+error, 'JAVA SERVERLET', {confirmButtonText: 'Chiudi' })
      })
      }
    }
}
</script>
<style>
.site-footer{
    background: #7474C1;
    padding:10px 0;
    color:#ffffff;
    
    font-size: 1.4rem;
    margin: 40px 0 0 0;
}
</style>

